<div class="p-6 product-review-container flex-table-page">
  <!-- Header with Tabs -->
  <div class="mb-6 flex-table-header">
    <h2 class="text-2xl font-semibold text-gray-800 mb-4">
      {{ "goods.product_review.title" | translate }}
    </h2>

    <!-- Tab Navigation -->
    <div class="flex">
      <button
        class="px-6 py-3 text-sm font-medium border-b-2 transition-colors"
        [class]="
          activeTab() === 'ordinary'
            ? 'border-blue-500 text-blue-600'
            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
        "
        (click)="onTabChange('ordinary')"
      >
        {{ "goods.product_review.tabs.product_sku_approval" | translate }}
      </button>
      <button
        class="px-6 py-3 text-sm font-medium bordsition-colors opacity-50 cursor-not-allowed"
        disabled
      >
        {{ "goods.product_review.tabs.bundle_sku_approval" | translate }}
      </button>
    </div>
  </div>

  <!-- Search Form -->
  <app-search-form
    [searchFormat]="searchFields()"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  ></app-search-form>

  <!-- Data Table -->
  <div class="flex-table-section">
    <app-data-table
      [dataSource]="filteredItems()"
      [columns]="tableColumns"
      [loading]="loading()"
      [totalRecords]="totalItems()"
      [rows]="itemsPerPage()"
      [first]="currentPage() * itemsPerPage()"
      [hasCheckColumn]="false"
      scrollHeight="flex"
      (pageChange)="onPageChange($event)"
    >
    <!-- Custom Material Template -->
    <ng-template
      #customTemplate
      let-materialUrl
      let-rowData
      let-column="column"
    >
      @if (column && column.prop === "materialMainImage") {
        <div class="flex justify-center items-center">
          @if (materialUrl) {
            <button
              type="button"
              class="p-0 border-0 bg-transparent cursor-pointer"
              [attr.aria-label]="rowData.materialName"
              (click)="onCheck(rowData)"
            >
              <img
                [src]="materialUrl"
                [alt]="rowData.materialName"
                class="w-8 h-8 rounded object-cover"
              />
            </button>
          }
        </div>
      } @else if (column && column.prop === "auditCommitDate") {
        <div class="flex justify-center items-center">
          <span class="text-sm text-gray-600">
            {{ formatDate(materialUrl) }}
          </span>
        </div>
      } @else if (column && column.template === "categoryTemplate") {
        <span
          class="text-xs text-gray-700 truncate cursor-help"
          [pTooltip]="materialUrl"
          tooltipPosition="top"
          tooltipStyleClass="custom-tooltip"
          [showDelay]="300"
          [hideDelay]="0"
        >
          {{ materialUrl | lastCategory }}
        </span>
      } @else {
        <!-- Fallback for other custom columns -->
        <div class="flex justify-center items-center">
          <span class="text-sm text-gray-600">
            {{ materialUrl || "-" }}
          </span>
        </div>
      }
    </ng-template>

    <!-- Custom Status Template -->
    <ng-template #statusTemplate let-status>
      <div class="flex items-center justify-center gap-1">
        <p-tag
          [value]="getStatusDisplayText(status)"
          [severity]="getStatusSeverity(status)"
          styleClass="status-tag"
          [ngStyle]="getStatusStyle(status)"
          pTooltip="{{ status }}"
          tooltipPosition="top"
          tooltipStyleClass="custom-tooltip"
          [showDelay]="300"
          [hideDelay]="0"
        />
      </div>
    </ng-template>

    <!-- Custom Actions Template -->
    <ng-template #actionsTemplate let-rowData>
      <div class="flex gap-2 justify-center">
        <app-button
          class="action-view"
          [label]="'goods.product_review.actions.view' | translate"
          type="action"
          (emitOnClick)="onCheck(rowData)"
        ></app-button>
        @if (rowData.status === 2 || rowData.status === 4) {
          <app-button
            class="action-audit"
            [label]="'goods.product_review.actions.approve' | translate"
            type="action"
            (emitOnClick)="onAudit(rowData)"
          ></app-button>
        }
      </div>
    </ng-template>
    </app-data-table>
  </div>
</div>
